import script from "./CategoryManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryManagement.vue?vue&type=script&setup=true&lang=js"

import "./CategoryManagement.vue?vue&type=style&index=0&id=3bede694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bede694"]])

export default __exports__